/**
 * Formatuje adres do wyświetlenia
 *
 * @export
 * @param {*} address
 * @returns {string}
 */
export function formatAddress(address: any): string {
  if (!address) {
    return '';
  }

  const commaValues = [address.city, address.postCode, address.street];
  return [
    commaValues.filter(Boolean).join(', '),
    address.nr ? address.nr + (address.localNr ? '/' + address.localNr : '') : ''
  ]
    .filter(Boolean)
    .join(' ');
}
